module.exports = __webpack_public_path__ + "img/preset6.e36e920e.png";